import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../http.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-front-page-form',
  templateUrl: './front-page-form.component.html',
  styleUrls: ['./front-page-form.component.scss']
})
export class FrontPageFormComponent implements OnInit {

  @ViewChild('f', { static: false }) f : NgForm

  public data : any = {status: 1}
  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      this.loadData(params['page_uuid']);
    });
  }

  ngOnInit(): void {
  }

  async loadFile(fileInput: any, name: string) {
    this.data[name] = await this.http.fileChangeEvent(fileInput);
  }

  async submit() {
    
    const s = await this.http.post("/admin/page/update", this.data);

    if (s['status']) {
      this.http.naviBack();
    } else {
      alert(s['message']);
    }
    
  }

  async loadData(page_uuid) {
    this.data = await this.http.post("/admin/page/get", {page_uuid});
  }
}
